import React from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import useStyles from "../styles";
import Card from "@material-ui/core/Card";
import { useTheme } from "@material-ui/core/styles";
const TravellerDetail = ({ passengerDetail = [] }) => {
  const theme = useTheme();
  const classes = useStyles();
  const getPaxType = (paxType = 0) => {
    switch (paxType) {
      case 1:
        return "Adult";
      case 2:
        return "Child";
      case 3:
        return "Infant";
      default:
        return "";
    }
  };

  const TravellerNames = () => {
    return (
      <Box mt={2} mb={2}>
        <Typography
          style={{
            color: theme?.agentTheme?.card?.foreground,
            fontWeight: 600,
            fontSize: "16px",
          }}
        >
          Traveller Name
        </Typography>
        {passengerDetail.map((pax, index) => {
          let { title = "", firstname = "", lastname = "", paxtype = 0 } = pax;
          return (
            <Box mt={3} mb={3} display="grid" rowGap="12px">
              <Typography
                style={{ color: theme?.agentTheme?.card?.foreground }}
              >
                {`${index + 1}. ${title} ${firstname} ${lastname}`}&nbsp;&nbsp;
                <span style={{ color: theme?.agentTheme?.text?.light }}>
                  {getPaxType(paxtype)}
                </span>
              </Typography>
            </Box>
          );
        })}
      </Box>
    );
  };

  return (
    <Box mt={2}>
      <Card className={classes.paddedCards}>
        <Box pt={"12px"} pl={2}>
          <Box
            mb={1}
            display="flex"
            justifyContent="space-between"
            width="100%"
          >
            <Typography variant="subtitle1" className={classes.overviewText}>
              Traveller Information{" "}
            </Typography>
          </Box>
          <Divider
            style={{ backgroundColor: theme.agentTheme.card.muted_foreground }}
          />
          <TravellerNames />
        </Box>
      </Card>
    </Box>
  );
};

export default TravellerDetail;
